import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { getLocalStorageItem } from '../../../services/StorageService';
import { UserKpisList } from './UserKpisList';
import { CreateKpi } from './CreateDefaultKpis';
import { getCycleDefaultSelection, getUserDetails } from '../../../config/utils';
import {
	getAdminDefaultKpiList,
	getDefaultKpiCycleDetails,
	getKpiProgress,
	highlightKpi,
	setKpiFilters,
	setKpiListReload,
	setShowKpiCreateOpen,
} from '../../../action/MyKpis';
import { Enums } from '../../../config/enums';
import { MyProgress } from '../MyProgress';

export const MyKpis: React.FC<any> = (props: any) => {
	const { handleEditOrgKpisClick, showApiMsg, currentUser } = props;
	const [showLoader, setShowLoader] = useState(false);
	const [openCloneDialog, setOpenCloneDialog] = useState<any>({
		open: false,
		openId: 0,
	});

	const { t } = useTranslation();
	const [isCreateOpen, setIsCreateOpen] = useState<any>(false);
	const { cycleDetailsForDefaultKpi, highlightedId } = useSelector((state: any) => state.kpiReducer);
	const { reloadKpiList, showKpiCreateOpen, dashboardProgressData, finalFilterCondition, defaultSearchFilter } =
		useSelector((state: any) => state.kpiReducer);
	const cycleId = getLocalStorageItem('cycleId2') ? parseInt(getLocalStorageItem('cycleId2') || '0') : 0;
	const [selectedCycleDetails, setSelectedCycleDetails] = useState<any>(null);
	const [currentCycleId, setCurrentCycleId] = useState(0);
	const dispatch = useDispatch();
	const [listLoading, setListLoading] = useState(false);
	const [listingData, setListingData] = useState<any>([]);
	const [kpiDataList, setKpiDataList] = useState<any>([]);

	const [isAllowToSendApproval, setIsAllowToSendApproval] = useState<boolean>(false);
	const [kpiProgressCardData, setKpiProgressCardData] = useState<any>({});
	const [highlightDefaultOkr, setHighlightDefaultOkr] = useState<string>('');
	const userDetail: any = getUserDetails();
	const selectedYear = getLocalStorageItem('year') || null;
	const [appliedFilter, setAppliedFilter] = useState<boolean>(false);
	useEffect(() => {
		setIsCreateOpen(showKpiCreateOpen);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showKpiCreateOpen]);

	useEffect(() => {
		setAppliedFilter(false);
		if (currentCycleId !== cycleId) {
			defaultOkrAPICall(true, false);
			setCurrentCycleId(cycleId);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectedCycleDetails, cycleId]);
	useEffect(() => {
		if (reloadKpiList === true) {
			defaultOkrAPICall();
			dispatch(setKpiListReload(false));
			console.log('reloadKpiList', reloadKpiList);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [reloadKpiList]);
	useEffect(() => {
		setListingData([]);
		dispatch(getDefaultKpiCycleDetails(`organisationId=${userDetail.organisationId}&cycleType=2`));
		dispatch(setShowKpiCreateOpen(false));

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	useEffect(() => {
		if (
			cycleDetailsForDefaultKpi &&
			cycleDetailsForDefaultKpi.cycleDetails &&
			cycleDetailsForDefaultKpi.cycleDetails.length
		) {
			let currentQuarterDetails: any = getCycleDefaultSelection(cycleDetailsForDefaultKpi.cycleDetails, cycleId);
			if (currentQuarterDetails) {
				setSelectedCycleDetails({ ...currentQuarterDetails });
				setCurrentCycleId(currentQuarterDetails?.organisationCycleId || currentCycleId);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [cycleDetailsForDefaultKpi]);

	const setFinalFilterCondition = (filters: any) => {
		dispatch(setKpiFilters(filters));
		dispatch(setKpiListReload(true));
	};
	const getEmployeeId = () => {
		return currentUser ? currentUser.employeeId : userDetail.employeeId;
	};

	const getKpiUser = () => {
		return currentUser ? currentUser : userDetail;
	};
	const getPerformanceReviewList = async (requestPayload: any) => {
		const response: any = await dispatch(getAdminDefaultKpiList(requestPayload));
		if (response && response?.data && response?.data?.status === Enums.STATUS_SUCCESS) {
			setKpiDataList(response.data.entity);
			setListingData(response.data.entity.myGoalKpiResponse);
			setIsAllowToSendApproval(response.data.entity?.isAllowToSendApproval || false);
			setKpiProgressCardData(response.data.entity.kpiProgressCard);
			let hasRepublish = 0;
			let hasPublish = 0;
			response.data.entity.myGoalKpiResponse.forEach((okrAssignType: any) => {
				if (okrAssignType.status === 4) {
					hasRepublish = 4;
				} else if (okrAssignType.status === 3) {
					hasPublish = 3;
				}
			});
			//setReublishButton(hasRepublish);
			//setPublishButton(hasPublish);
			//setAlertMessage(response.data.entity.unpublishedMessage);
			setTimeout(() => {
				//setHighlightDefaultOkr(0);
			}, 5000);
			if (highlightDefaultOkr) {
				scrollTo(`default_okr_list_item_index_${highlightDefaultOkr}`);
			}
		} else {
			const { messageList } = response?.data || {};
			const keys = messageList ? Object.keys(messageList) : null;
			const messages = keys && keys?.length ? keys.map((item) => messageList[item]) : [];
			showApiMsg('error', messages || 'Error occurred while fetching default okr details');
		}
		setListLoading(false);
	};

	const scrollTo = (elementId: string) => {
		setTimeout(function () {
			let element = document.getElementById(elementId);
			let topPos = element?.offsetTop;
			topPos = topPos ? topPos - 100 : 0;
			if (element) {
				element.scrollIntoView({ behavior: 'smooth' });
				window.scroll({ top: topPos, behavior: 'smooth' });
			}
		}, 800);
	};
	const defaultOkrAPICall = (showLoading = true, useFilters = true) => {
		if (1 || selectedCycleDetails) {
			//console.trace();
			showLoading && setListLoading(true);
			let filters: any = { ...finalFilterCondition };
			// Parameter for post
			let filterPostData: any = {
				cycle: cycleId,
				empId: getEmployeeId(),
				objectiveId: 0,
				progressTypeIds: [],
				kpiTypeIds: [],
			};
			if (useFilters) {
				if (filters.status && filters?.status.length > 0) {
					filterPostData.progressTypeIds = finalFilterCondition.status.map((item: any) => item.id);
				}
				if (filters.kpiCategoryMasterId && filters?.kpiCategoryMasterId.length > 0) {
					filterPostData.kpiTypeIds = finalFilterCondition.kpiCategoryMasterId.map((item: any) => item.id);
				}
			}
			getPerformanceReviewList(filterPostData);
			dispatch(setShowKpiCreateOpen(false));
			//const data = `empId=${getEmployeeId()}&cycle=${cycleId}&year=${selectedYear}`;
			const data = `empId=${getEmployeeId()}&cycle=${cycleId}`;
			dispatch(getKpiProgress(data, true));
			//progresscardapi call
		}
	};

	const [expandedKrList, setExpandedKrList] = useState<number[]>([]);
	useEffect(() => {
		if (highlightedId?.kpiId && listingData && listingData.length > 0) {
			setExpandedKrList([...expandedKrList, highlightedId?.kpiId]);
			setTimeout(() => {
				console.log('highlightedId - ININ', highlightedId);
				dispatch(highlightKpi({}));
			}, 5000);
		}
	}, [highlightedId, listingData]);
	const handleExpandKeyResult = (e: any, okr: any) => {
		let list = Object.assign([], expandedKrList);
		const elementIndex = list.indexOf(okr.goalObjectiveId);
		if (elementIndex !== -1) {
			list.splice(elementIndex, 1);
		} else {
			list.push(okr.goalObjectiveId);
		}
		setExpandedKrList(list);
	};
	//handleCardClick
	return (
		<>
			{
				<MyProgress
					{...props}
					cardDashboard={dashboardProgressData}
					dashboardProgressData={dashboardProgressData}
					handleCardClick={() => {}}
				/>
			}
			{isCreateOpen && (
				<CreateKpi {...props} setIsCreateOpen={setIsCreateOpen} getEmployeeId={getEmployeeId} getKpiUser={getKpiUser} />
			)}
			<UserKpisList
				{...props}
				listLoading={listLoading}
				expandedKrList={expandedKrList}
				setExpandedKrList={setExpandedKrList}
				handleExpandKeyResult={handleExpandKeyResult}
				isAllowToSendApproval={isAllowToSendApproval}
				setIsCreateOpen={setIsCreateOpen}
				showLoader={showLoader}
				setShowLoader={setShowLoader}
				selectedCycleDetails={selectedCycleDetails}
				setSelectedCycleDetails={setSelectedCycleDetails}
				listingData={listingData}
				defaultOkrAPICall={defaultOkrAPICall}
				currentCycleId={currentCycleId}
				setCurrentCycleId={setCurrentCycleId}
				handleEditOrgKpisClick={handleEditOrgKpisClick}
				allCycleDetails={cycleDetailsForDefaultKpi}
				setListingData={setListingData}
				getEmployeeId={getEmployeeId}
				getKpiUser={getKpiUser}
				cycleId={cycleId}
				defaultSearchFilter={defaultSearchFilter}
				finalFilterCondition={finalFilterCondition}
				setFinalFilterCondition={setFinalFilterCondition}
				appliedFilter={appliedFilter}
				setAppliedFilter={setAppliedFilter}
				kpiDataList={kpiDataList}
				setKpiDataList={setKpiDataList}
			/>
		</>
	);
};
